import cx from 'classnames';
import type React from 'react';
import Select, {
  GroupBase,
  MultiValue,
  OptionProps,
  SingleValue,
} from 'react-select';
import { Icons } from '@/shared/Icons/Icons';
import styles from './styles.module.css';

export type ItemSelectT = {
  value: string;
  title: string;
  slug?: string;
};

type SelectSimpleProps = {
  options: ItemSelectT[];
  selected?: ItemSelectT | null | undefined;
  className?: string;
  isSearchable?: boolean;
  placeholder?: string;
  onChange: (option: ItemSelectT | null) => void;
  defaultValue?: ItemSelectT | null;
  error?: boolean;
  instanceId?: string;
};

const SelectMain: React.FC<SelectSimpleProps> = ({
  options,
  selected,
  className = '',
  isSearchable = false,
  placeholder = '',
  onChange,
  defaultValue,
  error,
  instanceId,
}) => {
  const handleSelectChange = (
    option: MultiValue<ItemSelectT> | SingleValue<ItemSelectT> | null,
  ) => {
    onChange(Array.isArray(option) ? option[0] : option);
  };

  const Option = (
    props: OptionProps<ItemSelectT, boolean, GroupBase<ItemSelectT>>,
  ) => {
    const { isSelected, children } = props;
    return (
      <div
        {...props.innerProps}
        className={cx(styles.option, isSelected && styles.active)}
      >
        <div className={styles.optionContent}>
          {children}
          {isSelected && <Icons.Mark className={styles.checkmark} />}
        </div>
      </div>
    );
  };

  return (
    <Select
      value={selected}
      className={`${className}`}
      placeholder={placeholder}
      components={{ Option }}
      classNames={{
        container: () => styles.container,
        control: ({ menuIsOpen }) =>
          cx(
            styles.selectSimpleControl,
            error ? styles.error : '',
            menuIsOpen ? styles.openMenu : '',
          ),
        indicatorSeparator: () => styles.indicatorSeparator,
        option: ({ isSelected }) =>
          cx(styles.option, isSelected && styles.active),
        menu: () => styles.menu,
        valueContainer: () => styles.valueContainer,
        input: () => styles.input,
        indicatorsContainer: ({ selectProps }) => {
          return cx(
            styles.indicatorsContainer,
            selectProps.menuIsOpen && styles.rotateIndicator,
          );
        },
      }}
      onChange={handleSelectChange}
      getOptionLabel={(vehicle: ItemSelectT) => vehicle.title}
      getOptionValue={(vehicle: ItemSelectT) => vehicle.value}
      options={options}
      backspaceRemovesValue={true}
      isSearchable={isSearchable}
      defaultValue={defaultValue}
      instanceId={instanceId}
    />
  );
};

export default SelectMain;
